<template>
  <div class="card border-0 rounded" style="box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10), 0 6px 10px 0 rgba(0, 0, 0, 0.01); overflow: hidden; height: 100vh;">
      <div class="card bg-image border-0 m-0 p-0" style="position: absolute; top: 0px; bottom: 0px; right: 0px; left: 0px;">
        
        <div style="position: absolute; top: 150px; width: 100%; font-size: 1.5rem;">
          <vue-typer :text="textToWrite" @completed='onComplete' :repeat='0' pre-type-delay='500'></vue-typer>
        </div>

        <div style="margin: auto; z-index: 99;">
          <b-form @submit="onSubmit" v-show="showInput" style="margin-top: 50px;">
            <b-form-group>
              <b-form-input id="nickname" v-model.trim="login.nickname" placeholder="Name?"></b-form-input>
            </b-form-group>
            <b-button type="submit" variant="btn btn-secondary">Enter</b-button>
          </b-form>
        </div>
      </div>
  </div>
</template>

<script>

import router from '../router'
import Moment from 'moment';

export default {
  name: 'AddBoard',
  data () {
    return {
      login: { nickname: this.$route.params.nickname },
      showInput: false,
      textToWrite: ["Welcome to Te Matuku Tech", "Join us for a chat", "What's your name?"]
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault();

      if(!this.login.nickname.trim()) { return; }

      router.push({
        name: 'Chat',
        params: { nickname: this.login.nickname, roomid: Moment(new Date).format('YYYYMMDD')}
      })
    },
    onComplete: function() {
      this.showInput = true;
    }
  }
}
</script>

<style>
  .jumbotron {
    padding: 2rem;
  }
</style>